import type { ComponentType } from 'react';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncResizeButtonTooltip = lazyAfterPaint<ComponentType<Props>>(
	() => import(/* webpackChunkName: "async-sidebar-resize-button" */ './main'),
	{
		ssr: false,
	},
);
